import { defineNuxtPlugin } from "#app";
import { registerErrorCategory } from "~/composables/useErrorHandler";
import { LOGIN_ERRORS } from "~/components/Page/Login/errors";

export default defineNuxtPlugin(() => {
  // Register all error categories here
  registerErrorCategory("login", LOGIN_ERRORS);
});
